import React from "react";
import "./styles/spinner.css";

const Spinner: React.FC = () => {
  return (
    <div className="spinner-container">
      <div className="spinner-wrapper">
        <img
          src="/images/logopreview.png"
          alt="Logo"
          className="spinner-logo"
        />
        <svg className="spinner" role="progressbar" aria-label="Loading">
          <circle className="spinner__track"></circle>
          <circle className="spinner__indicator"></circle>
        </svg>
      </div>
    </div>
  );
};

export default Spinner;
